const standardStyling =
  "absolute border-b-2 border-l-2 rounded-bl-[1rem] cursor-pointer transition-all duration-200";

const standardHoverFocus =
  "absolute -left-2 -right-2 -top-2 -bottom-2 cursor-pointer"; // This is used to make the clickable area wider, making it easier to click

export { standardStyling, standardHoverFocus };
